import { z } from 'zod';
import { emailFieldSchema, passwordFieldSchema } from './fields';

export const signUpSchema = (t) =>
  z.object({
    email: emailFieldSchema(t),
    password: passwordFieldSchema(t),
  });
